"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _index = require("../../index");
var _newComponents = require("../../new-components");
var BookingNavbarLink = function BookingNavbarLink(_ref) {
  var route = _ref.route,
    location = _ref.location,
    disabled = _ref.disabled,
    active = _ref.active,
    setActiveLink = _ref.setActiveLink;
  var _useMeasure = (0, _index.useMeasure)(),
    _useMeasure2 = (0, _slicedToArray2["default"])(_useMeasure, 2),
    refNavbarLink = _useMeasure2[0],
    measureNavbarLink = _useMeasure2[1];
  if (active) setActiveLink(measureNavbarLink);
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
    ref: refNavbarLink,
    to: {
      pathname: route.pathname,
      search: location.search
    },
    onClick: function onClick(e) {
      return disabled && e.preventDefault();
    },
    style: {
      pointerEvents: disabled ? 'none' : 'auto',
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
    text: route.title,
    buttonType: _newComponents.BUTTON_TYPES.FILTER_PROGRESS,
    active: active
  }));
};
BookingNavbarLink.propTypes = {
  route: _propTypes["default"].object,
  location: _propTypes["default"].object,
  disabled: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  setActiveLink: _propTypes["default"].func
};
var _default = exports["default"] = BookingNavbarLink;